import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { startWith, take } from 'rxjs';
import { AppMessageService, AuthService } from './shared/services';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly authService = inject(AuthService);
  private readonly appMessageService = inject(AppMessageService);
  private readonly currentUser = toSignal(
    this.authService
      .userChanges()
      .pipe(startWith(this.authService.currentUser)),
    { initialValue: this.authService.currentUser },
  );

  private readonly loadMessages = effect(() => {
    if (!this.currentUser()) {
      return;
    }

    this.appMessageService.load().pipe(take(1)).subscribe();
  });
}
